import type { ActionJournal } from "./action-queue";
import { z } from "zod";
import { ActionBatch } from "../../shared/actions";
import { validateState } from "../../shared/validation";
export function parseJournal(value: unknown): ActionJournal {
  const data = z
    .object({
      base: z.unknown(),
      pending: z
        .array(
          z.object({
            id: z.uuid(),
            actions: ActionBatch.shape.actions,
            context: z.string().max(50000).nullable(),
            compute: z.boolean(),
            applied: z.unknown().optional(),
            label: z.string().max(500).optional(),
          }),
        )
        .max(5000),
    })
    .parse(value);
  return {
    base: validateState(data.base),
    pending: data.pending.map((item) => ({
      ...item,
      applied: item.applied ? validateState(item.applied) : undefined,
    })),
  };
}
let database: Promise<IDBDatabase> | undefined;
function open() {
  return (database ??= new Promise((resolve, reject) => {
    const request = indexedDB.open("cretchess-pending-changes", 1);
    request.onupgradeneeded = () =>
      request.result.createObjectStore("workspaces");
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  }));
}
export async function readOutbox(
  key: string,
): Promise<ActionJournal | undefined> {
  try {
    const db = await open();
    const value = await new Promise((resolve, reject) => {
      const request = db
        .transaction("workspaces")
        .objectStore("workspaces")
        .get(key);
      request.onsuccess = () => resolve(request.result);
      request.onerror = () => reject(request.error);
    });
    return value ? parseJournal(value) : undefined;
  } catch {
    return undefined;
  }
}
export async function writeOutbox(key: string, journal: ActionJournal) {
  const copy = structuredClone(journal);
  try {
    const db = await open();
    await new Promise<void>((resolve, reject) => {
      const transaction = db.transaction("workspaces", "readwrite"),
        store = transaction.objectStore("workspaces");
      if (copy.pending.length) store.put(copy, key);
      else store.delete(key);
      transaction.oncomplete = () => resolve();
      transaction.onerror = () => reject(transaction.error);
    });
  } catch {
    /* Saving still works; beforeunload protects in-memory pending work. */
  }
}
